/*

Sainapse® incorporates patented, and “patent pending”, technology.

© 2017 - 2024 Sainapse Inc. and its licensors. All rights reserved worldwide.

Sainapse Inc. and its licensors own all rights in this work, including but not limited to the source code, algorithms, text, 
flowcharts and images herein, which are protected by copyright laws in applicable jurisdictions. Any use of this work is permissible 
only with an express written license or authorization from Sainapse Inc., and only to the extent and for the purpose permitted. 
Unauthorized copying, editing, reproduction, redistribution, modification, creation of derivative works, translation, adaptation, 
customization, decompilation, reverse engineering, disassembling or hacking of this work or any part thereof, including but not limited to the source code, 
header files and libraries of the software, via any medium is strictly prohibited.

Open Source Software that is provided as part of Sainapse® is subject to and governed solely by the terms and conditions of the applicable open source license agreements, 
and their respective terms, conditions, restrictions and obligations, a copy of which will be made available to you upon request.

Proprietary and Confidential. Sainapse® and associated documentation is the property of Sainapse Inc. and considered confidential information. 
No part of it may be disclosed without the express written consent of Sainapse Inc.Please note that any infringement or violation will invite legal action, 
both civil and criminal, as appropriate, without any further notice.

*/
import React, { Component, Fragment } from 'react';
import { withStyles, createTheme, ThemeProvider } from '@material-ui/core/styles'

import { Paper, Typography, Divider, Tabs, Tab, Switch, TextField, Button, FormControl, FormHelperText,InputLabel, Select, MenuItem, IconButton, Input, Chip } from '@material-ui/core'
import { Clear, DeleteOutline, TimerSharp } from '@material-ui/icons';
import FlexFormGenerator from '../../../FlexFormGenerator/FlexFormGenerator'
import { v4 as uuidv4 } from 'uuid';

const AntTabs = withStyles({
    root: {
      borderBottom: '1px solid #e8e8e8',
    },
    indicator: {
      backgroundColor: '#1890ff',
    },
})(Tabs);

const AntTab = withStyles((theme) => ({
    root: {
        textTransform: 'none',
        minWidth: 72,
        fontWeight: theme.typography.fontWeightRegular,
        marginRight: theme.spacing(2),
        padding : theme.spacing(1),
        fontFamily: [
        '-apple-system',
        'BlinkMacSystemFont',
        '"Segoe UI"',
        'Roboto',
        '"Helvetica Neue"',
        'Arial',
        'sans-serif',
        '"Apple Color Emoji"',
        '"Segoe UI Emoji"',
        '"Segoe UI Symbol"',
        ].join(','),
        '&:hover': {
        color: '#40a9ff',
        opacity: 1,
        },
        '&$selected': {
        color: '#1890ff',
        fontWeight: theme.typography.fontWeightMedium,
        },
        '&:focus': {
        color: '#40a9ff',
        },
    },
    selected: {},
}))((props) => <Tab disableRipple {...props} />);

const blue_theme = createTheme({
    palette: {
      primary: {
        main: "#2296f3",
      },
      secondary: {
        main: "#dc004e",
      },
    },
});

const styles = theme => ({})
class ExternalSources extends Component {
    contentHeight = React.createRef();
    state = {
        external_sources : [],
        tab_height : null
    } 

    componentDidMount () {
        const tab_height = this.contentHeight.current.clientHeight
        this.setState({...this.state, tab_height : tab_height})
    }
    
    addExternalSource = () => {
        const external_source_temp = {
            id : uuidv4(),
            link_id : "",
            link_name : "",
            query_map : []
        }

        let external_sources = [...this.props.external_sources]
        external_sources.push(external_source_temp)
        this.props.update_parent(external_sources)
        this.setState({...this.state, external_sources : external_sources})
    }

    deleteExternalSource = (source_id) => {
        let external_sources = [...this.props.external_sources]
        let source_index = external_sources.findIndex(src => src.id === source_id)
        external_sources.splice(source_index, 1)
        this.props.update_parent(external_sources)
        this.setState({...this.state, external_sources : external_sources})
    }

    getParameters = (screen) => {
        let parameter = []
        if (screen === "CaseScreen") {
            parameter = this.props.columns.map(column => {
                let field = {
                    "value" : column,
                    "name" : column
                }
                return field
            })
        } else {
            if( this.props.search_type === "freetext") {
                let field = {
                    "value" : "searchtext",
                    "name" : "searchtext"
                }
                parameter.push(field)
            } else {
                parameter = this.props.search_fields
            }  
        }
        return parameter
    }

    renderExternalSource = (source, edit) => {
        let routes = JSON.parse(sessionStorage.getItem('ui_routes')).drawer
        let links_section = routes.find(section => section.id === 'links')
        let links = links_section.screens
        let parameters = this.getParameters(this.props.screen)

        return (
            <Paper key = {source.link_id} variant = 'outlined' style = {{width : '100%', padding : '10px', marginBottom : '10px'}}>
                <div style = {{width : '100%', display : 'flex', flexDirection : 'row', alignItems : 'center'}}>
                    <div style = {{flexGrow : 1}}>
                            <FormControl style = {{width : '50%'}} disabled = {!edit}>
                            <InputLabel id="demo-simple-select-label">Link</InputLabel>
                            <Select
                                labelId="demo-simple-select-label"
                                id="demo-simple-select"
                                value = {source.link_id}
                                onChange = {(event) => {
                                    let sources = [...this.props.external_sources]
                                    let update_source_index = sources.findIndex(src => src.link_id === source.link_id)

                                    let link_index = links.findIndex(link => link.id === event.target.value)
                                    let query_map = links[link_index].default_params.query_params.map(qp => {
                                        return {
                                            key_name : qp.key,
                                            value_map : []
                                        }
                                    })

                                    if (update_source_index !== -1) {
                                        sources[update_source_index].link_id = event.target.value
                                        sources[update_source_index].link_name = links[link_index].name
                                        sources[update_source_index].query_map = query_map
                                        this.props.update_parent(sources)
                                        this.setState({...this.state, external_sources : sources})
                                    }
                                }}
                            >
                                {links.map(link => {
                                    return (
                                        <MenuItem value={link.id}>{link.name}</MenuItem>
                                    )
                                })}
                            </Select>
                        </FormControl>
                    </div>
                    <div>
                        <IconButton 
                            disabled = {!edit}
                            size = 'small' 
                            color = 'secondary' 
                            onClick = {() => this.deleteExternalSource(source.id)}>
                            <Clear fontSize = 'small'/>
                        </IconButton>
                    </div>
                </div>
                {console.log("external source ::", source)}
                {source.query_map.length > 0 && <div style = {{marginTop : '10px', padding : '5px'}}>
                    <Typography style = {{margin : '5px'}} variant = 'overline'>Query Parameters</Typography>
                    {source.query_map.map(qm => {
                        return (
                            <Paper variant = 'outlined' style = {{width : '100%', display : 'flex', marginBottom : '10px', flexDirection : 'row', alignItems : 'center'}}>
                                <div style = {{width : '40%', padding : '5px'}}>
                                    <Typography variant = 'caption'>Key Name</Typography>
                                    <Typography style = {{margin : '5px'}} variant = 'subtitle2'>{qm.key_name}</Typography>
                                </div>
                                <div style = {{width : '60%', padding : '5px'}}>
                                    <FormControl style = {{width : '100%'}} disabled = {!edit}>
                                        <InputLabel id="demo-simple-select-label">Param Value</InputLabel>
                                        <Select
                                            labelId="demo-simple-select-label"
                                            id="demo-simple-select"
                                            multiple
                                            value={qm.value_map}
                                            input={<Input id="select-multiple-chip" />}
                                            renderValue={(selected) => (
                                                <div>
                                                {selected.map((value) => (
                                                    <Chip key={value} style = {{marginLeft: '5px'}} label={value}/>
                                                ))}
                                                </div>
                                            )}
                                            onChange = {(event) => {
                                                console.log("Updating Source : ", event.target.value)
                                                let sources = [...this.props.external_sources]
                                                let update_source_index = sources.findIndex(src => src.link_id === source.link_id)

                                                if (update_source_index !== -1) {
                                                    let qm_index = sources[update_source_index].query_map.findIndex(query => query.key_name === qm.key_name)
                                                    sources[update_source_index].query_map[qm_index].value_map = event.target.value
                                                    console.log("Updated Source : ", sources[update_source_index])
                                                    this.props.update_parent(sources)
                                                    this.setState({...this.state, external_sources : sources})
                                                }
                                            }}
                                        >
                                            {/* {this.state.search_type === 'freetext' ? <MenuItem value={'searchtext'}>Search Text</MenuItem> :
                                                this.state.search_fields.map(field => {
                                                    return (
                                                        <MenuItem value={field.name}>{field.name}</MenuItem>
                                                    )
                                                })} */}
                                                {console.log("parameters :: ", parameters)}
                                                {
                                                    parameters.map(field => {
                                                        return (
                                                            <MenuItem value={field.name}>{field.name}</MenuItem>
                                                        )
                                                    })
                                                }
                                        </Select>
                                    </FormControl>
                                </div>
                            </Paper>
                        )
                    })}
                </div>}
            </Paper>
        )
    }

    render() {
        return (
            <div style = {{width : '100%', padding : '5px'}} ref={this.contentHeight}>
                <Typography style = {{display : 'block'}} variant = 'subtitle2'>External Sources</Typography>
                <Divider style = {{marginTop : '5px', marginBottom : '5px'}}/>
                <div style = {{padding : '10px'}}>
                    {this.props.external_sources.map(external_source => {
                        return this.renderExternalSource(external_source, this.props.edit)
                    })}
                </div>
                <Button
                    variant = 'outlined'
                    style = {{marginLeft : '10px'}}
                    disabled = {!this.props.edit}
                    color = 'primary'
                    size='small'
                    onClick = {() => this.addExternalSource()} 
                >Add External Source</Button>
            </div>
        )
    }
}

export default withStyles(styles)(ExternalSources);